export const pt = {
  pt: {
    translation: {
      confirm_app_exit: 'Certeza que deseja sair do Mundo Bebê Tubarão pra Criança?',
      button_exit: 'Sair',
      button_cancel: 'Cancelar',
      os_update: 'Atualize o Sistema Operacional da TV e tente novamente.',
      button_ok: 'OK',
      t_complete_app_update: 'O Mundo Bebê Tubarão pra Criança foi atualizado.',
      error_title: 'Ocorreu um erro',
      error_unknown: 'Por favor reinicie o aplicativo.',
      error_network_title: 'Conexão instável.',
      error_network: 'Verifique sua conexão e tente novamente.',
      button_retry: 'Repetir',
      confirm_continue_watching: 'Gostaria de continuar assistindo?',
      button_continue_watching: 'Continuar Assistindo',
      button_from_beginning: 'Comece do Início',
      t_event_coming_soon: 'Estamos preparando eventos.',
      data_fail: 'Ocorreu um erro. \nPor favor reinicie o aplicativo.',
      page_sign_in_header: 'Faça login com código QR',
      page_sign_in: 'Login necessário para usar o serviço.\nLeia o código QR para fazer login.',
      page_sign_in_code: 'Código de Verificação',
      page_sign_in_time: 'Tempo Restante',
      oauth_confirm_code: 'Favor, verifique\nse coincide ao código de verificação da TV',
      oauth_web_info: 'Navegador da Web',
      oauth_device_info: 'Informações de acesso ao dispositivo',
      oauth_accept_sign_in: 'Aceitar login',
      oauth_sign_in_success: 'Login no dispositivo bem-sucedido.',
      oauth_sign_in_cancel: 'Login no dispositivo cancelado.',
      oauth_sign_in_fail: 'Erro.\nTente de novo com o código QR.',
      oauth_sign_in_expired: 'Sessão de login expirou.\nLeia de novo o código QR da TV e faça login.',
      menu_my: 'PERFIL',
      menu_home: 'Início',
      menu_story: 'História',
      menu_song: 'Canção',
      menu_cinema: 'Cinema',
      menu_cinema_and_tv: 'Cinema e Séries de TV',
      menu_ip: 'IP',
      menu_topics: 'Tópicos',
      menu_home_history: 'Assistidos Recentemente',
      title_ai_videos: 'Vídeos Selecionados por IA',
      menu_home_new_content: 'Novidades',
      player_language_ko: '한국어',
      player_language_en: 'English',
      player_language_zh: '中文',
      player_language_pt: 'Português',
      player_language_es: 'Español',
      player_language_ja: '日本語',
      player_language_id: 'Bahasa Indonesia',
      mypage_menu_status_unsusbcribed: 'Nenhuma assinatura ativa',
      mypage_menu_status_susbcribed: '<span class="text-secondary">Assinado</span> no Pinkfong Plus',
      mypage_menu_benefits_unsusbcribed: 'Benefícios da Assinatura',
      mypage_menu_benefits_susbcribed: 'Benefícios Atuais',
      mypage_menu_benefits_01: 'Mais de 20.000 séries originais disponíveis',
      mypage_menu_benefits_02: 'Conteúdo exclusivo atualizado',
      mypage_menu_benefits_03: 'Com uma única assinatura,\nacesso na TV e no celular',
      mypage_menu_benefits_04: 'Mais de 30 Apps de aprendizagem\ncom acesso ilimitado',
      mypage_scan_to_subscribe: 'Leia o código QR para assinar',
      mypage_video_title: 'O que é Pinkfong Plus?',
      mypage_menu_terms: 'Termos e Condições',
      mypage_menu_event: 'Promoção',
      mypage_menu_support: 'Suporte',
      button_sign_out: 'Sair',
      mypage_menu_event_coming_soon: 'Em breve',
      mypage_menu_even_open: 'Abrir',
      terms_required_privacy: 'Política de Privacidade.',
      terms_required_pinkfong: 'Termos de Serviço.',
      terms_required_interactive: 'Termos dos Apps interativos Pinkfong.',
      mypage_menu_device_info: 'Informação de Dispositivo',
      page_device_info: 'Contate-nos com essas informações para resolução do problema.',
      page_device_info_model: 'Modelo do Dispositivo',
      page_device_info_os: 'Sistema Operacional',
      page_device_info_version: 'Versão do App',
      page_support: 'Para assistência, entre em contato.\ncs@pinkfong.com',
      caution_sign_out: 'Sair restringirá o acesso ao serviço.',
      topic_category_all: 'All',
      player_language_button: 'Idioma',
    },
  },
};
